import { validateConstant } from "@constants";

export function getTagsForValidation (state = {}, action) {
    switch (action.type) {
        case validateConstant.GET_TAGS_FOR_VALIDATION_REQUEST:
            return { 
                ...state,
                isLoading: true 
            };
        case validateConstant.GET_TAGS_FOR_VALIDATION_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false
            };
        case validateConstant.GET_TAGS_FOR_VALIDATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default: return state;
    }
};